export enum LayoutConstants {
  LAYOUT_TOGGLE_AUTHORISE_ACCOUNTS = 'LAYOUT_TOGGLE_AUTHORISE_ACCOUNTS',
  LAYOUT_TOGGLE_ACCOUNT_DETAILS = 'LAYOUT_TOGGLE_ACCOUNT_DETAILS',
  LAYOUT_TOGGLE_PASSWORD = 'LAYOUT_TOGGLE_PASSWORD',
  LAYOUT_TOGGLE_IMAGE_PREVIEW = 'LAYOUT_TOGGLE_IMAGE_PREVIEW',
  LAYOUT_TOGGLE_ADD_NEW_SCOPE = 'LAYOUT_TOGGLE_ADD_NEW_SCOPE',
  LAYOUT_TOGGLE_EDIT_PLAN = 'LAYOUT_TOGGLE_EDIT_PLAN',
}

export enum AccountConstants {
  ACCOUNT = 'ACCOUNT',
  SAVE_DEVELOPER_PROFILE = 'SAVE_DEVELOPER_PROFILE',
  SAVE_USER_DATA = 'SAVE_USER_DATA',
  ADD_NEW_SCOPES = 'ADD_NEW_SCOPES',
  EDIT_APP_PLAN = 'EDIT_APP_PLAN',
}
